interface Props {
  src: string;
  title: string;
  subtitle?: string;
  ctaText?: string;
  ctaHref?: string;
}

function HeroContent(props: Props) {
  return (
    <div class="hero-content">
      <h1>{props.title}</h1>
      {props.subtitle && <p class="hero-subtitle">{props.subtitle}</p>}
      {props.ctaText && props.ctaHref && (
        <a class="cta-button themed hero-cta" href={props.ctaHref}>
          {props.ctaText}
        </a>
      )}
    </div>
  );
}

export function HeroSection(props: Props) {
  if (props.src.match(/\.mp4$/)) return VideoHero(props);
  return HeroImage(props);
}

export function VideoHero(props: Props) {
  return (
    <section class="hero video">
      <video
        src={props.src}
        autoplay
        playsinline
        controls={false}
        loop
        muted
        preload="none"
        poster={props.src + '.webp'}
      >
      </video>
      <HeroContent {...props} />
    </section>
  );
}

export function HeroImage(props: Props) {
  return (
    <section
      class="hero"
      style={{
        backgroundImage: `url('${props.src}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <HeroContent {...props} />
    </section>
  );
}
